import CryptoJS from "crypto-js";

let cv = "";

export const generateRandomString = (length: number): string => {
  let text = "";

  const codeVerifier = localStorage.getItem("code_verifier");

  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== "") {
    cv = codeVerifier;

    return codeVerifier;
  } else {
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    cv = text;

    localStorage.setItem("code_verifier", cv);

    return text;
  }
};

export const generateCodeChallenge = (codeVerifier: string): string => {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));

  return codeChallange + "&code_challenge_method=S256";
};

function base64URL(string: any): string {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
